/**
 * Serialiation Strategy, extend to flag support
 *
 * This is a base class so instanceof works at runtime in ts 2.0
 *
 *
 */

export abstract class CubiqPrototypal {
  constructor(_serializedObject?: CubiqPrototypal) {
    if (_serializedObject !== undefined) {
      Object.assign(this, _serializedObject);
    }
  }
}
